'use client';

import { ReactNode, createContext, useEffect, useState } from 'react';

export const StepContext = createContext<{
  stepIndex: number;
  isDirty: boolean;
  setStepIndex: (index: number) => void;
  setIsDirty: (isDirty: boolean) => void;
}>({
  stepIndex: 0,
  isDirty: false,
  setStepIndex: () => {},
  setIsDirty: () => {},
});

export const StepContextProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [isDirty, setIsDirty] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    setIsDirty(false);
  }, [stepIndex]);

  return (
    <StepContext.Provider value={{ isDirty, setIsDirty, stepIndex, setStepIndex }}>
      {children}
    </StepContext.Provider>
  );
};
